import { TokenService, TOKEN_SERVICE } from './token.service';
import { UserManager } from 'oidc-client';
import * as angular from "angular";

export const AUTH_SERVICE = "authService";

export class AuthService {
    private get TOKEN_KEY() { return "accessToken"; }

    private storage: Storage;

    static $inject = ["$window"];
    constructor($window: ng.IWindowService) {
        this.storage = $window.sessionStorage;
    }

    getAccessToken() {
        return this.storage.getItem(this.TOKEN_KEY);
    }

    signout() {
        this.storage.removeItem(this.TOKEN_KEY);
    }

    getLoggedIn() { return angular.isDefined(this.getAccessToken()); }
}

export function boardWebLogin(userManager: UserManager, tokenService: TokenService) {
    return userManager.getUser().then(user => {
        if (user != null && !user.expired) {
            return user;
        }

        return userManager.signinPopup().then(user => {
            tokenService.boardWebAccessToken = user.access_token;
            return user;
        });
    });
}
boardWebLogin.$inject = ["BoardWebUserManager", TOKEN_SERVICE];


// WEBPACK FOOTER //
// ./app/core/auth.service.ts